// extracted by mini-css-extract-plugin
module.exports = {"hoverMessageLine2":"_bfca17d9"};